import React from "react";
import { AbsoluteFill, interpolate, useCurrentFrame } from "remotion";
import ProjectCard from "../components/ProjectCard";
import { SceneHeading, SceneTint } from "../components/SceneChrome";
import { projectById } from "../data/resume";

// Fixed constellation of points for the neural-thread background.
const THREAD_POINTS = [
  [200, 200], [520, 130], [900, 240], [1300, 150], [1700, 260],
  [320, 560], [760, 640], [1150, 560], [1580, 620], [960, 900],
] as const;
const THREADS: [number, number][] = [
  [0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [1, 6], [2, 6], [2, 7],
  [3, 7], [4, 8], [5, 6], [6, 7], [7, 8], [6, 9], [7, 9],
];

// Scene 4 — 4Mation (45–60%): the visual gear-shift into the AI era.
// Neural threads draw in behind three AI-project cards.
const Scene44Mation: React.FC = () => {
  const frame = useCurrentFrame();
  const qvego = projectById("qvego");
  const montgomery = projectById("montgomery");
  const ida = projectById("ida");

  return (
    <AbsoluteFill style={{ backgroundColor: "#15121d" }}>
      <svg
        width={1920}
        height={1080}
        viewBox="0 0 1920 1080"
        style={{ position: "absolute", inset: 0 }}
      >
        {THREADS.map(([a, b], i) => (
          <line
            key={i}
            x1={THREAD_POINTS[a][0]}
            y1={THREAD_POINTS[a][1]}
            x2={THREAD_POINTS[b][0]}
            y2={THREAD_POINTS[b][1]}
            stroke="#C084FC"
            strokeWidth={2}
            pathLength={1}
            strokeDasharray={1}
            strokeDashoffset={interpolate(
              frame,
              [i * 2, 18 + i * 2],
              [1, 0],
              { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
            )}
            opacity={0.25 + 0.15 * Math.sin(frame / 7 + i)}
          />
        ))}
        {THREAD_POINTS.map(([x, y], i) => (
          <circle
            key={i}
            cx={x}
            cy={y}
            r={6}
            fill="#C084FC"
            opacity={interpolate(frame, [i * 2, 10 + i * 2], [0, 0.7], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            })}
          />
        ))}
      </svg>
      <SceneTint color="#C084FC" enterFrame={6} intensity={0.5} />
      <SceneHeading
        title="4Mation Technologies — Fullstack Engineer"
        subtitle="AI, automation & tech lead"
        color="#C084FC"
        enterFrame={4}
      />
      <AbsoluteFill
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 44,
          paddingTop: 70,
          scale: "0.92",
        }}
      >
        {[qvego, montgomery, ida].map((project, i) => {
          const Icon = project.icon;
          return (
            <ProjectCard
              key={project.id}
              title={project.title}
              client={project.client}
              color={project.color}
              bullets={project.bullets}
              stack={project.stack}
              size="deck"
              enterFrame={16 + i * 18}
              flipFrame={95 + i * 10}
              icon={<Icon sx={{ fontSize: 52 }} />}
            />
          );
        })}
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

export default Scene44Mation;
